module.exports = new __parcel__URL__("board.a55a3491.svg").toString();